import { useEffect, useState } from 'react';

import { ArticlesRefreshStatus } from './ArticlesSection.types';

const SUCCESS_DISPLAY_MS = 10_000;

export const useRefreshButtonSuccess = (refreshStatus: ArticlesRefreshStatus) => {
  const [showSuccess, setShowSuccess] = useState(false);

  useEffect(() => {
    if (refreshStatus !== 'success') {
      setShowSuccess(false);

      return;
    }

    setShowSuccess(true);

    const timeoutId = setTimeout(() => {
      setShowSuccess(false);
    }, SUCCESS_DISPLAY_MS);

    return () => clearTimeout(timeoutId);
  }, [refreshStatus]);

  return showSuccess;
};
